import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import IconButton from 'components/atoms/Button/IconButton';
import { disableAllMenu } from 'modules/actions/statusMenu';
import { sendSatisfy } from 'modules/actions/starScore';
import { disabledTabMoveButton, disabledTabMoveInput, fallbackTabMove} from 'helper/index';

const Satisfy = () => {
  const dispatch = useDispatch();
  const closeSatisfy = () => {
    dispatch(disableAllMenu());
    setPayloadStatus({ score: 5, name: '매우만족', content: '', status: 'N' });
    fallbackTabMove();
    document.querySelector('.type7').focus();
  };

  // state
  const [payloadStatus, setPayloadStatus] = useState({ score: 5, name: '매우만족', content: '' });
  const StarName = ['매우불편', '불편', '보통', '만족', '매우만족'];

  // event
  const setStarValue = (scoreStr, nameStr) => {
    setPayloadStatus({ ...payloadStatus, score: scoreStr, name: nameStr });
  };

  const setContentValue = contentStr => {
    if (contentStr) {
      setPayloadStatus({ ...payloadStatus, content: contentStr, status: 'Y' });
    } else {
      setPayloadStatus({ ...payloadStatus, content: contentStr, status: 'N' });
    }
  };

  useEffect(() => {
    disabledTabMoveButton(['ri-close-line satisfy','_quality_item','fd_send_btn','_at_icon_button_div satisfy']);
    disabledTabMoveInput();
  }, []);

  return (
    <div className="_satisfy_bg">
      <div className="feedback_area">
        <button type="button" className="ri-close-line satisfy" onClick={closeSatisfy} aria-label='닫기'/>

        <div className="fd_name">별을 탭하여 평가해주세요.</div>
        <div className="star_set">
          {StarName.map((name, i) => (
            <IconButton
              key={`_star_${i + 1}`}
              clickEvt={() => {
                setStarValue(i + 1, name);
              }}
              propName='satisfy'
              icon={payloadStatus.score >= i + 1 ? 'ri-star-fill' : 'ri-star-line'}
              styleDef={{ width: '40px', fontSize: '30px', height: '40px', color: '#40609D' }}
              starName={name}
            />
          ))}
        </div>
        <div className="fd_score_name">{payloadStatus.name}</div>
        <textarea
          maxLength="300"
          className="feed_input_textarea"
          placeholder="의견을 남겨주세요."
          aria-label="별점에 대한 의견을 남겨주세요."
          title="별점에 대한 의견을 남겨주세요."
          value={payloadStatus.content}
          onChange={e => {
            setContentValue(e.target.value);
            // dispatch(changeStarScore({ score: currentStarScore.score, name: currentStarScore.name, content: e.target.value }));
          }}
        />
        <button
          type='button'
          className="fd_send_btn"
          onClick={() => {
            if (!sessionStorage.getItem('satisfy_status')) {
              sessionStorage.setItem('satisfy_status', 'N');
            }
            if (sessionStorage.getItem('satisfy_status') === 'Y') {
              const sign = window.confirm('이미 만족도 평가를 완료하셨습니다. 수정하시겠습니까?');
              if (sign) {
                dispatch(sendSatisfy(payloadStatus));
                setPayloadStatus({ score: 5, name: '매우만족', content: '' });
              }
            } else {
              dispatch(sendSatisfy(payloadStatus));
              setPayloadStatus({ score: 5, name: '매우만족', content: '' });
              sessionStorage.setItem('satisfy_status', 'Y');
            }
            fallbackTabMove();
            dispatch(disableAllMenu());
          }}
          aria-label='확인'
        >
          확인
        </button>
      </div>
    </div>
  );
};

export default Satisfy;
